import { useParams } from "react-router-dom";
import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import GroupsContent from "./GroupsContent";
import { useBreadcrumb } from "@/components/breadcrumbs";

const Groups = () => {
  const { queryHash } = useParams<{ queryHash?: string }>();
  useBreadcrumb("Groups", {
    defaultParents: [{ label: "Code", pathname: "/query" }],
    truncateTo: "/query",
  });

  return (
    <DatatableContextProvider>
      <GroupsContent queryHash={queryHash} />
    </DatatableContextProvider>
  );
};

export default Groups;
